/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid, DialogContentText } from '@material-ui/core';
import { Table, DefaultFiltro, DialogDefault } from '../../../components';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsModuleConfiguration from '../../../store/moduleConfiguration/reducer';
import { deleteProduto, exportProduto } from '../../../store/produto/actions';
import { PRODUTO_PEDIDO_DELETE_ACCESS } from '../../../constants/modules';
import ProdutoFormulario from './ProdutoFormulario';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main
  },
  iconValidate: {
    marginRight: theme.spacing(1),
    color: 'green'
  },
  iconInvalidate: {
    marginRight: theme.spacing(1),
    color: 'red'
  }
}));

const hasPermission = (moduleConfigurations, authData) =>
  moduleConfigurations?.some(
    u => u.codigo === PRODUTO_PEDIDO_DELETE_ACCESS && u.userId === authData.id
  );

const Produtos = ({ deleteProduto, exportProduto, authData, moduleConfigurations }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [titles] = useState(['Produto', 'Ativo', 'Quantidade', 'Possui Tamanho', 'Descrição']);
  const [localFilter, setLocalFilter] = useState({
    codigo: undefined
  });
  const [openReport, setOpenReport] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [reload, setReload] = useState(null);
  const [forceDeleteOpen, setForceDeleteOpen] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);
  const [conflictMessage, setConflictMessage] = useState('');
  const tableReloadRef = useRef(() => {});

  const classes = useStyles();
  const canDelete = hasPermission(moduleConfigurations, authData);

  const renderRows = d => {
    return (
      <>
        <TableCell size="small">{d.nome}<br/>({d.codigo})</TableCell>
        <TableCell size="small">{d.ativo === 'true' || d.ativo === true ? 'Sim' : 'Não'}</TableCell>
        <TableCell size="small">{d.estoqueTotal || '0'}</TableCell>
        <TableCell size="small">{d.possuiTamanho === 'true' || d.possuiTamanho === true ? 'Sim' : 'Não'}</TableCell>
        <TableCell size="small">{d.descricao}</TableCell>
      </>
    )
  }

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onDelete = (rowId, reload) => {
    tableReloadRef.current = reload;
    deleteProduto(rowId, reload, {
      onVinculos409: msg => {
        setConflictMessage(msg || '');
        setPendingDeleteId(rowId);
        setForceDeleteOpen(true);
      },
    });
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const handleForceDeleteClose = () => {
    setForceDeleteOpen(false);
    setPendingDeleteId(null);
    setConflictMessage('');
  };

  const handleForceDeleteConfirm = () => {
    deleteProduto(
      pendingDeleteId,
      () => {
        handleForceDeleteClose();
        tableReloadRef.current();
      },
      { force: true }
    );
  };

  const onClose = (isSave) => {
    setOpen(false);
    setId(null);

    if (isSave) {
      setReload(true);
    }
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <DefaultFiltro
            useAtivo
            useCodigo
            codigoLabel="Código do Produto"
            mdCodigo="6"
            useNome
            nomeLabel="Nome do Produto"
            mdNome="6"
            filterData={localFilter}
            onFilter={filter => {
              setLocalFilter(filter);
            }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={[]}
          titles={titles}
          headerTitle="Produtos"
          deleteMessage="O produto será removido e não poderá ser mais recuperado."
          showDelete
          showDeleteRow={() => canDelete}
          onDelete={onDelete}
          renderRows={renderRows}
          onEdit={onEdit}
          hasRowActions
          onAdd={onAdd}
          useFilterData
          usePaginationApi
          paginationApi="produtos/filter"
          paginationUrl="produtos"
          filterData={localFilter}
          reload={reload}
        />
        <ProdutoFormulario
          id={id}
          open={open}
          onClose={onClose}
        />
      </Grid>
      <DialogDefault
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => {
          exportProduto(localFilter, false, () => {
            setOpenExport(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja exportar os produtos filtrados? </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openReport}
        handlerCancel={() => setOpenReport(false)}
        handlerConfirm={() => {
          exportProduto(localFilter, true, () => {
            setOpenReport(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja gerar o relatório dos produtos filtrados? </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={forceDeleteOpen}
        handlerCancel={handleForceDeleteClose}
        handlerConfirm={handleForceDeleteConfirm}
        title="Exclusão com vínculos"
        confirmMessage="Excluir mesmo assim"
        cancelMessage="Cancelar"
      >
        <DialogContentText>
          {conflictMessage}
          {' '}
          Deseja excluir o produto mesmo assim? Esta ação não poderá ser desfeita.
        </DialogContentText>
      </DialogDefault>
    </>
  );
};

Produtos.propTypes = {
  deleteProduto: PropTypes.func.isRequired,
  exportProduto: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
  moduleConfigurations: PropTypes.array,
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  deleteProduto,
  exportProduto,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Produtos));
